export const statesPage = {
  message: 'OK',
  data: [
    {
      id: '1',
      label: 'Amazonas'
    },
    {
      id: '2',
      label: 'Anzo\u00e1tegui'
    },
    {
      id: '3',
      label: 'Apure'
    },
    {
      id: '4',
      label: 'Aragua'
    },
    {
      id: '5',
      label: 'Barinas'
    },
    {
      id: '6',
      label: 'Bol\u00edvar'
    },
    {
      id: '7',
      label: 'Carabobo'
    },
    {
      id: '8',
      label: 'Cojedes'
    },
    {
      id: '9',
      label: 'Delta Amacuro'
    },
    {
      id: '10',
      label: 'Distrito Capital'
    },
    {
      id: '11',
      label: 'Falc\u00f3n'
    },
    {
      id: '12',
      label: 'Gu\u00e1rico'
    },
    {
      id: '13',
      label: 'Lara'
    },
    {
      id: '14',
      label: 'M\u00e9rida'
    },
    {
      id: '15',
      label: 'Miranda'
    },
    {
      id: '16',
      label: 'Monagas'
    },
    {
      id: '17',
      label: 'Nueva Esparta'
    },
    {
      id: '18',
      label: 'Portuguesa'
    },
    {
      id: '19',
      label: 'Sucre'
    },
    {
      id: '20',
      label: 'T\u00e1chira'
    },
    {
      id: '21',
      label: 'Trujillo'
    },
    {
      id: '22',
      label: 'Vargas'
    },
    {
      id: '23',
      label: 'Yaracuy'
    },
    {
      id: '24',
      label: 'Zulia'
    }
  ],
  status: 200
}

export const citiesPage = {
  message: 'OK',
  data: [
    {
      id: '104',
      label: 'ALTO ORINOCO'
    },
    {
      id: '98',
      label: 'ATABAPO'
    },
    {
      id: '99',
      label: 'ATURES'
    },
    {
      id: '100',
      label: 'AUTANA'
    },
    {
      id: '101',
      label: 'MANAPIARE'
    },
    {
      id: '102',
      label: 'MAROA'
    },
    {
      id: '1',
      label: 'PUERTO AYACUCHO'
    },
    {
      id: '103',
      label: 'RIO NEGRO'
    }
  ],
  status: 200
}

export const sectorPage = {
  message: 'OK',
  data: [
    {
      id: 409,
      label: 'HUACHAMACARE'
    },
    {
      id: 408,
      label: 'LA ESMERALDA'
    },
    {
      id: 410,
      label: 'MARAWAKA'
    },
    {
      id: 411,
      label: 'SIERRA PARIMA'
    }
  ],
  status: 200
}
